export default [
  'code',
  'description',
  'type',
  'status',
  { key: 'action', label: '' }
]
